import { render, staticRenderFns } from "./WhatsappDraft.vue?vue&type=template&id=0b2a2943&scoped=true"
import script from "./WhatsappDraft.vue?vue&type=script&lang=js"
export * from "./WhatsappDraft.vue?vue&type=script&lang=js"
import style0 from "./WhatsappDraft.vue?vue&type=style&index=0&id=0b2a2943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2a2943",
  null
  
)

export default component.exports